import { render } from "./UpcomingBooking.vue?vue&type=template&id=5a590d6c"
import script from "./UpcomingBooking.vue?vue&type=script&lang=js"
export * from "./UpcomingBooking.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__